const Resources = {

    table_headers: [
        { 
          text: 'Name',
          align: 'start',
          value: 'associate_name',
          type:  'link',
        },
        {
            text: 'Email',
            value: 'email'
        },
        {
            text: 'Country',
            value: 'country'
        },
        {
            text: 'Supervisor',
            value: 'supervisor'
        },
        {
            text:   'Reports to',
            value:  'reports_to',
        },
        {
            text:   'Role',
            value:  'role',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associates',
            href:   '/associates',
            arrow:  "",
        },
    ],

}

export default Resources